module.exports = __WEBPACK_EXTERNAL_MODULE_48__;


//////////////////
// WEBPACK FOOTER
// external "amplify-pubsub"
// module id = 48
// module chunks = 0